export { WatchProjectView } from './WatchProjectView'
export type { WatchProjectViewProps } from './WatchProjectView'
